export const containerIds = {
  calendarGrid: 'calendarGrid',
  choosePeriod: 'choosePeriod',
  localTaskPopover: 'localTaskPopover',
  daylongTasksDay: 'daylongTasksDay',
  daylongTasksWeek: 'daylongTasksWeek',
};
